import { render } from "./MenusPage.vue?vue&type=template&id=94d990f0&ts=true"
import script from "./MenusPage.vue?vue&type=script&lang=ts"
export * from "./MenusPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__